import { CrtRolePermissions } from '../../permissions'

const CRT_USER: CrtRolePermissions = {
  crt_agreements_create: false,
  crt_agreements_view: true,
  crt_async_exports_view: true,
  crt_audit_trails_view: true,
  crt_azure_imports_delete: false,
  crt_azure_imports_manage: false,
  crt_azure_imports_view: true,
  crt_brand_variants_view: true,
  crt_budget_allocations_create: false,
  crt_budget_allocations_delete: false,
  crt_budget_allocations_edit: false,
  crt_budget_allocations_view: true,
  crt_budget_estimates_edit: false,
  crt_budget_tracker_view: true,
  crt_calculation_run_accruals_create: false,
  crt_calculation_run_accruals_delete: false,
  crt_calculation_run_accruals_edit: false,
  crt_calculation_run_accruals_view: true,
  crt_bpc_actuals_view: true,
  crt_bpc_actuals_create: false,
  crt_bpc_actuals_edit: false,
  crt_bpc_actuals_delete: false,
  crt_channel_mix_create: false,
  crt_channel_mix_delete: false,
  crt_channel_mix_edit: false,
  crt_channel_mix_view: true,
  crt_commercial_partners_view: true,
  crt_consumer_rates_edit: false,
  crt_consumer_rates_view: true,
  crt_currency_rates_manage: false,
  crt_cost_of_goods_create: false,
  crt_cost_of_goods_delete: false,
  crt_cost_of_goods_edit: false,
  crt_cost_of_goods_view: true,
  crt_versions_approve: false,
  crt_versions_create: false,
  crt_versions_delete: false,
  crt_versions_edit: false,
  crt_versions_view: true,
  crt_lmc_targets_edit: false,
  crt_lmc_targets_view: true,
  crt_distribution_banner_mix_edit: false,
  crt_distribution_banner_mix_view: true,
  crt_distribution_margin_mix_create: false,
  crt_distribution_margin_mix_delete: false,
  crt_distribution_margin_mix_edit: false,
  crt_distribution_margin_mix_view: true,
  crt_federal_excise_edit: false,
  crt_federal_excise_view: true,
  crt_investments_view: true,
  crt_invites_delete: false,
  crt_invites_send: false,
  crt_invites_view: false,
  crt_ip_accruals_create: false,
  crt_ip_accruals_delete: false,
  crt_ip_accruals_edit: false,
  crt_ip_accruals_export: true,
  crt_ip_accruals_view: true,
  crt_key_account_contract_estimates_delete: false,
  crt_key_account_contract_estimates_edit: false,
  crt_key_account_contract_estimates_view: true,
  crt_key_accounts_view: true,
  crt_manual_investments_create: false,
  crt_manual_investments_delete: false,
  crt_manual_investments_edit: false,
  crt_manual_investments_view: true,
  crt_materials_materials_list_view: true,
  crt_materials_price_list_view: true,
  crt_notifications_manage: false,
  crt_notifications_view: false,
  crt_pe_pricing_assumptions_create: false,
  crt_pe_pricing_assumptions_delete: false,
  crt_pe_pricing_assumptions_edit: false,
  crt_pe_pricing_assumptions_view: true,
  crt_pe_pricing_rate_table_view: true,
  crt_pe_tax_assumptions_create: false,
  crt_pe_tax_assumptions_delete: false,
  crt_pe_tax_assumptions_edit: false,
  crt_pe_tax_assumptions_view: true,
  crt_product_type_variant_create: false,
  crt_product_type_variant_view: true,
  crt_product_types_edit: false,
  crt_product_types_view: true,
  crt_material_group_overrides_edit: false,
  crt_material_group_overrides_view: true,
  crt_agreement_mappings_edit: false,
  crt_agreement_mappings_view: true,
  crt_rap_forecasts_create: false,
  crt_rap_forecasts_delete: false,
  crt_rap_forecasts_edit: false,
  crt_rap_forecasts_view: true,
  crt_retailer_margins_fmc_edit: false,
  crt_retailer_margins_fmc_view: true,
  crt_retailer_margins_nc_edit: false,
  crt_retailer_margins_nc_view: true,
  crt_retailer_rates_edit: false,
  crt_retailer_rates_view: true,
  crt_roles_view: false,
  crt_sales_deal_actuals_create: false,
  crt_sales_deal_actuals_delete: false,
  crt_sales_deal_actuals_edit: false,
  crt_sales_deal_actuals_export: true,
  crt_sales_deal_actuals_view: true,
  crt_pnl_actuals_view: true,
  crt_pnl_forecasts_view: true,
  crt_price_list_snapshots_refresh: false,
  crt_unreleased_materials_edit: false,
  crt_unreleased_materials_view: true,
  crt_upload_allUploads_view: false,
  crt_upload_myUpload_view: false,
  crt_users_manageAccess: false,
  crt_users_view: false,
  crt_variance_analysis_view: true,
  crt_volume_forecasts_configure: false,
  crt_volume_forecasts_view: true,
  crt_volume_scenarios_view: true,
  crt_volume_scenarios_create: false,
  crt_volume_scenarios_edit: false,
  crt_volume_scenarios_delete: false,
  crt_wholesaler_margins_fmc_edit: false,
  crt_wholesaler_margins_fmc_view: true,
  crt_wholesaler_margins_nc_edit: false,
  crt_wholesaler_margins_nc_view: true,
}

export default CRT_USER
